module.exports = __webpack_public_path__ + "img/quizstarleftsection.405dfa17.png";